<template>
  <div class="card">
    <h1>Reestablecer contraseña</h1>
    <div v-if="changed" class="changed-password">
      <div class="alert success">
        <vs-icon icon="check_circle"></vs-icon>
        ¡Contraseña actualizada con éxito!
      </div>
      <div>
        Ya puede ingresar con su nueva contraseña.
      </div>
      <vs-button color="success" type="filled" to="/">Volver al inicio</vs-button>
    </div>
    <div v-else class="reset-form">
      <div v-if="resetToken">
        <p>
          Recuerde que deberá iniciar sesión nuevamente en todos los dispositivos una vez que genere su nueva contresaña
        </p>
        <vs-input name="password"
                  v-validate="'required|min:6'"
                  :danger="this.errors.has('password')"
                  :danger-text="this.errors.first('password')"
                  type="password"
                  size="large"
                  label-placeholder="Contraseña"
                  ref="password"
                  v-model="password">
        </vs-input>
        <vs-input name="password_confirmation"
                  v-validate="'required|confirmed:password'"
                  :danger="this.errors.has('password_confirmation')"
                  :danger-text="this.errors.first('password_confirmation')"
                  type="password"
                  size="large"
                  label-placeholder="Confirmar contraseña"
                  v-model="passwordConfirmation">
        </vs-input>
        <div class="center">
          <vs-button v-if="resetToken" @click="resetPassword" :class="{loading: loading}" color="primary" type="filled">Reestablecer</vs-button>
          <router-link to="/" class="forgot-password">Volver</router-link>
        </div>
      </div>
      <div v-else>
        <div class="alert danger">
          <vs-icon icon="error"></vs-icon>
          Para modificar su contraseña deberá acceder desde el link que llegó a su correo.
        </div>
        <vs-button type="filled" to="/">Volver al inicio</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'

const resetPassword = gql`
  mutation resetPassword($resetPasswordToken: String!, $password: String!) {
    resetPassword(resetPasswordToken: $resetPasswordToken, password: $password) {
      success
      message
      code
    }
  }
`

export default {
  name: 'ForgotPasswordForm',
  data: function () {
    return {
      password: '',
      passwordConfirmation: '',
      loading: false,
      resetToken: '',
      changed: false
    }
  },
  beforeMount () {
    this.resetToken = this.$route.query.reset_token
  },
  methods: {
    resetPassword () {
      this.$validator.validate().then((res) => {
        if (res) {
          this.loading = true
          axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
            query: print(resetPassword),
            variables: {
              resetPasswordToken: this.resetToken,
              password: this.password
            }
          }).then(res => {
            if (!res.data.errors) {
              if (res.data.data.resetPassword.success) {
                this.changed = true
                this.loading = false
              } else {
                this.$vs.notify({
                  title: 'Error al reestablecer contraseña',
                  time: 8000,
                  text: this.$t(`graph.${res.data.data.resetPassword.code}`),
                  color: '#eb4d4b',
                  position: 'top-center',
                  icon: 'error'
                })
                this.loading = false
              }
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
  .card {
    text-align: center;
  }

  .reset-form {
    text-align: initial;
  }
</style>
